var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.577,
    height: 19.8,
    viewBox: "0 0 22.577 19.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#04363d;}.b{fill:#58b354;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -32.867)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(17 35.867)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M360.011,243.976v4.77a1.342,1.342,0,0,1-1.343,1.338h-4.651a.662.662,0,0,1-.661-.661c0-.643-.355-3.9-.355-5.446A2.989,2.989,0,0,1,355.994,241h1.023A2.989,2.989,0,0,1,360.011,243.976Z",
    transform: "translate(-337.434 -198.828)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1 35.867)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.011,243.976c0,1.595-.355,4.774-.355,5.446a.662.662,0,0,1-.661.661H1.3A1.3,1.3,0,0,1,0,248.792v-4.816A2.989,2.989,0,0,1,2.994,241H4.017a2.989,2.989,0,0,1,2.994,2.976Z",
    transform: "translate(0 -198.828)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(7 32.867)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M132.906,246.337v3.614a1.546,1.546,0,0,1-1.544,1.544h-8.818A1.546,1.546,0,0,1,121,249.951v-3.614A5.343,5.343,0,0,1,126.337,241h1.233A5.343,5.343,0,0,1,132.906,246.337Z",
    transform: "translate(-115.664 -198.828)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalUsers);
export default __webpack_public_path__ + "static/media/total_users.8080097488c33496ecf2af189b53788a.svg";
export { ForwardRef as ReactComponent };